import React, { useEffect, useRef } from 'react';
interface FeatureProps {
  emoji: string;
  title: string;
  description: string;
  index: number;
}
function Feature({
  emoji,
  title,
  description,
  index
}: FeatureProps) {
  const featureRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('opacity-100', 'translate-y-0');
          entry.target.classList.remove('opacity-0', 'translate-y-10');
        }
      });
    }, {
      threshold: 0.1
    });
    if (featureRef.current) {
      observer.observe(featureRef.current);
    }
    return () => {
      if (featureRef.current) {
        observer.unobserve(featureRef.current);
      }
    };
  }, []);
  return <div ref={featureRef} className={`opacity-0 translate-y-10 transition-all duration-700 backdrop-blur-sm border border-black/5 dark:border-white/5 rounded-3xl p-8 hover:border-mint-500/20 dark:hover:border-mint-400/20 hover:shadow-lg hover:shadow-mint-500/5 dark:hover:shadow-mint-400/5 transition-all duration-500`} style={{
    transitionDelay: `${index * 100}ms`
  }} data-id="element-70">
      <div className="text-3xl mb-4" data-id="element-71">{emoji}</div>
      <h3 className="text-xl font-light mb-4" data-id="element-72">{title}</h3>
      <p className="text-black/60 dark:text-white/60 leading-relaxed" data-id="element-73">
        {description}
      </p>
    </div>;
}
export function Features() {
  const sectionRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('opacity-100');
          entry.target.classList.remove('opacity-0');
        }
      });
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <div id="features" ref={sectionRef} className="py-32 md:py-40 opacity-0 transition-opacity duration-1000" data-id="element-74">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-75">
        <h2 className="text-3xl md:text-4xl font-light mb-24 text-center" data-id="element-76">
          your{' '}
          <span className="text-mint-600 dark:text-mint-400" data-id="element-77">
            ai nutrition guide
          </span>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-78">
          <Feature index={0} emoji="💬" title="chat naturally" description="Talk to caltalk like a friend. No rigid commands—just say what you want. Find me lunch under 600 calories near downtown" data-id="element-79" />
          <Feature index={1} emoji="🎯" title="exact macros" description="Get precise protein, carbs, and fats for every meal. No more guessing. Know exactly what you're eating, every single time." data-id="element-80" />
          <Feature index={2} emoji="📍" title="location-aware" description="Find macro-friendly restaurants near you with distance and travel time. See what's within walking distance right now." data-id="element-81" />
          <Feature index={3} emoji="🧠" title="learns your taste" description="Caltalk remembers what you love and adapts its recommendations over time. The more you use it, the smarter it gets." data-id="element-82" />
          <Feature index={4} emoji="⚡" title="built for speed" description="Minimal design. No clutter. Just fast, clear answers when you need them. Ask, get results, move on with your day." data-id="element-83" />
        </div>
      </div>
    </div>;
}